import { TOTAL_COLUMNS } from './consts';
import DashboardWidget from '../../util/DashboardWidget';

export type IsOccupied = (
  column: number,
  row: number,
  widgets: DashboardWidget[],
  width: number,
  height: number,
) => boolean;

export const isOccupied: IsOccupied = (column, row, widgets, width, height) => {
  if (column + width > TOTAL_COLUMNS) {
    return true; // don't place off the edge to the right.
  }
  return !!widgets?.find((w) => {
    const leftEdge = w.x;
    const rightEdge = w.x + w.width - 1;
    const topEdge = w.y;
    const bottomEdge = w.y + w.height - 1;
    const columnLeftEdge = column;
    const columnRightEdge = column + width - 1;
    const isInColumn =
      leftEdge <= columnRightEdge && rightEdge >= columnLeftEdge;
    const isInRow = topEdge <= row + height - 1 && bottomEdge >= row;
    return isInColumn && isInRow;
  });
};
